import React, {FC, useRef, useState, useEffect, useCallback, useMemo} from 'react'
import {Form, Formik, useFormik} from 'formik'
import {ToastContainer, toast} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import {updateCustomer, createCustomer} from './Api'
import {
  customerSubTabs,
  customerTabs,
  ICustomerModel,
  initialCustomer,
  validationCustomer,
} from './CustomerModel'
import {
  COUNTRY_OPTIONS,
  CUSTOMER_CLASS,
  CUSTOMER_TYPES,
  HGS_TYPES,
  INVOICE_TYPES,
  LANGUAGE,
  LICENSE_CLASS,
  LICENSE_TYPES,
  RISK_TYPES,
  STOPPAGE_CODES,
  STOPPAGE_TYPES,
  YES_OR_NO,
} from '../../../shared/models/SharedConstantLookups'
import SelectInput from '../../../shared/components/SelectInput'
import {showErrorToast, showSuccessToast} from '../../../shared/components/ToastUtils'
import FormTabHeader from '../../../shared/components/FormTabHeader'
import TextInput from '../../../shared/components/TextInput'
import PhoneInput from '../../../shared/components/PhoneInput'
import CheckboxInput from '../../../shared/components/CheckboxInput'
import SubTabHeader from '../../../shared/components/SubTabHeader'
import TextAreaInput from '../../../shared/components/TextAreaInput'
import {
  branches,
  currencies,
  fetchAsyncReservationSourceData,
  personels,
  reservationSources,
  tariffs,
} from '../../../shared/models/SharedApiLookups'
import AsyncSearchInput from '../../../shared/components/AsyncSearchInput'
import { AsyncReservationSourceModel } from '../../../shared/models/ApiModels'
import { Button } from 'react-bootstrap-v5'

export const CustomerPage: FC = () => {
  const [tab, setTab] = useState<string | 'indivual'>('indivual')
  const [tabSub, setTabSub] = useState<string | 'address'>('address')
  const [loading, setLoading] = useState(false)
  const [selectedId, setSelectedId] = useState<string | null | undefined>(null)
  const [branchOptions, setBranchOptions] = useState<{value: string; label: string}[]>([])
  const [tariffOptions, setTariffOptions] = useState<{value: string; label: string}[]>([])
  const [reservationSourceOptions, setReservationSourceOptions] = useState<
    {value: string; label: string}[]
  >([])
  const [personelOptions, setPersonelOptions] = useState<{value: string; label: string}[]>([])
  const [currencyOptions, setCurrencyOptions] = useState<{value: string; label: string}[]>([])
  useEffect(() => {
    Promise.all([branches(), tariffs(), reservationSources(), personels(), currencies()]).then(
      ([brn, tr, rs, pr, cr]) => {
        setBranchOptions(brn)
        setTariffOptions(tr)
        setReservationSourceOptions(rs)
        setPersonelOptions(pr)
        setCurrencyOptions(cr)
      }
    )
  }, [])

  const handleSave = async (values: ICustomerModel, resetForm: () => void) => {
    setLoading(true)
    try {
      if (selectedId) {
        await updateCustomer({...values, id: selectedId, customerType: 'INDIVIDUAL'})
        showSuccessToast('Müşteri başarıyla güncellendi')
      } else {
        await createCustomer({...values, customerType: 'INDIVIDUAL'})
        showSuccessToast('Müşteri başarıyla oluşturuldu')
      }
      resetForm()
      setSelectedId(null)
    } catch (err) {
      showErrorToast('Bir hata oluştu')
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Formik
        initialValues={initialCustomer}
        validationSchema={validationCustomer}
        enableReinitialize
        onSubmit={(values, {resetForm}) => handleSave(values, resetForm)}
      >
        {(formik) => {
          const handleReset = () => {
            formik.resetForm()
            setSelectedId(null)
          }
          return (
            <>
              <FormTabHeader
                formId='customerForm'
                formikSubmit={formik.handleSubmit}
                formikReset={handleReset}
                loading={loading}
                tab={tab}
                setTab={setTab}
                setSelectedId={setSelectedId}
                tabs={customerTabs}
                onExportExcel={() => console.log('Excel export')}
              />
              <div className='card mb-5'>
                <Form id='customerForm' className='form card-body'>
                  {tab === 'indivual' && (
                    <div className='row g-5 align-items-center mb-2'>
                      <TextInput
                        max={11}
                        type='number'
                        name='tcKimlikNo'
                        label='T.C. Kimlik No'
                        wrapperClassName='col-md-6'
                      />
                      <TextInput
                        name='dateOfBirth'
                        type='date'
                        label='Doğum Tarihi'
                        wrapperClassName='col-md-2'
                      />
                         <TextInput
                        name='placeOfBirth'
                        label='Doğum Yeri'
                        wrapperClassName='col-md-4'
                      />
                      <TextInput name='firstName' label='Ad' wrapperClassName='col-md-6' />
                      <TextInput name='lastName' label='Soyad' wrapperClassName='col-md-6' />
                      <PhoneInput name='gsm1' label='GSM 1' wrapperClassName='col-md-6' />
                      <PhoneInput name='gsm2' label='GSM 2' wrapperClassName='col-md-6' />
                      <PhoneInput name='phone' label='Telefon' wrapperClassName='col-md-6' />
                      <TextInput name='emailAddress' label='E-posta' wrapperClassName='col-md-6' />
                      <TextInput
                        name='taxOffice'
                        label='Vergi Dairesi'
                        wrapperClassName='col-md-6'
                      />
                      <TextInput
                        name='taxNumber'
                        type='number'
                        label='Vergi No'
                        wrapperClassName='col-md-6'
                      />
                      <TextInput name='city' label='Şehir' wrapperClassName='col-md-6' />
                      <TextInput name='district' label='İlçe' wrapperClassName='col-md-6' />
                      <TextAreaInput
                        name='address'
                        label='Ev Adresi'
                        wrapperClassName='col-md-6'
                      /> 
                    </div>
                  )}
                  {tab === 'identity' && (
                    <div className='row g-5 align-items-center mb-2'>
                      <TextInput
                        name='drivingLicenseNo'
                        label='Ehliyet No'
                        wrapperClassName='col-md-6'
                      />
                      <TextInput
                        name='passportNumber'
                        label='Pasaport No'
                        wrapperClassName='col-md-6'
                      />
                      <TextInput
                        name='drivingLicenseIssueDate'
                        type='date'
                        label='Ehliyet Veriliş Tarihi'
                        wrapperClassName='col-md-6'
                      />
                      <TextInput
                        name='passportIssueDate'
                        type='date'
                        label='Pasaport Veriliş Tarihi'
                        wrapperClassName='col-md-6'
                      />
                      <TextInput
                        name='drivingLicenseIssuedBy'
                        label='Ehliyet Veren Yer'
                        wrapperClassName='col-md-6'
                      />
                      <TextInput
                        name='passportIssuedBy'
                        label='Pasaport Veren Yer'
                        wrapperClassName='col-md-6'
                      />
                      <SelectInput
                        name='drivingLicenseClass'
                        label='Ehliyet Sınıfı'
                        wrapperClassName='col-md-6'
                        options={LICENSE_CLASS}
                      />
                      <SelectInput
                        name='licenseCountry'
                        label='Ehliyet Ülkesi'
                        wrapperClassName='col-md-6'
                        options={COUNTRY_OPTIONS}
                      />
                      <SelectInput
                        name='licenseType'
                        label='Lisans Tipi'
                        wrapperClassName='col-md-6'
                        options={LICENSE_TYPES}
                      />
                    </div>
                  )}
                  {tab === 'detail' && (
                    <div className='row g-5 align-items-center mb-2'>
                      <TextInput name='specialCode' label='Özel Kod' wrapperClassName='col-md-3' />
                      <TextInput
                        name='integrationCode'
                        label='Entegrasyon Kodu'
                        wrapperClassName='col-md-3'
                      />
                      <TextInput
                        name='corporateNumber'
                        label='Kurumsal Numara'
                        wrapperClassName='col-md-3'
                      />
                      <TextInput
                        name='corporatePassword'
                        label='Kurumsal Şifre'
                        wrapperClassName='col-md-3'
                      />
                      <Button
                            type='button'
                            onClick={() => {
                              const password = Math.random().toString(36).substring(2, 15)
                              const corporateNumber = Math.random().toString(36).substring(2, 15)
                                formik.setFieldValue('corporatePassword', password)
                                formik.setFieldValue('corporateNumber', corporateNumber)
                            }}
                            className='btn btn-primary col-2'
                          >
                            Kod Üret
                          </Button>
                      <TextAreaInput
                        name='description'
                        label='Açıklama'
                        wrapperClassName='col-md-6'
                      />
                      <TextAreaInput
                        name='bankInformation'
                        label='Banka Bilgileri'
                        wrapperClassName='col-md-6'
                      />
                      <SelectInput
                        name='tariff'
                        label='Tarife'
                        wrapperClassName='col-md-6'
                        options={tariffOptions}
                      />
                      <TextInput
                        name='webDiscount'
                        type='number'
                        label='Web İndirimi'
                        wrapperClassName='col-md-3'
                      />
                      <TextInput
                        name='dealerCommissionRate'
                        type='number'
                        label='Bayi Komisyon Oranı'
                        wrapperClassName='col-md-3'
                      />
                      <SelectInput
                        name='invoiceAddressDifferent'
                        label='Fatura Adresi Farklı'
                        wrapperClassName='col-md-3'
                        options={YES_OR_NO}
                      />
                      <TextInput name='maturityDay' label='Vade Günü' wrapperClassName='col-md-3' />
                      <SelectInput
                        name='invoicePeriod'
                        label='Fatura Dönemi'
                        wrapperClassName='col-md-6'
                        options={INVOICE_TYPES}
                      />
                      <TextInput
                        name='riskMessage'
                        label='Risk Mesajı'
                        wrapperClassName='col-md-6'
                      />
                      <TextInput
                        name='warningMessage'
                        label='Uyarı Mesajı'
                        wrapperClassName='col-md-6'
                      />
                      <TextInput
                        name='riskMessageDate'
                        type='date'
                        label='Risk Mesajı Tarihi'
                        wrapperClassName='col-md-6'
                      />
                      <TextInput
                        name='warningTime'
                        type='datetime-local'
                        label='Uyarı Liste Zamanı'
                        wrapperClassName='col-md-6'
                      />
                      <SelectInput
                        name='riskPermit'
                        label='Risk İzni'
                        wrapperClassName='col-md-3'
                        options={RISK_TYPES}
                      />
                      <TextInput
                        name='riskLimit'
                        currency={true}
                        label='Risk Limiti'
                        wrapperClassName='col-md-3'
                      />
                      <SelectInput
                        name='operationBranch'
                        label='İşlem Şubesi'
                        wrapperClassName='col-md-6'
                        options={branchOptions}
                      />
                      <SelectInput
                        name='communicationLanguage'
                        label='İletişim Dili'
                        wrapperClassName='col-md-3'
                        options={LANGUAGE}
                      />
                      <SelectInput
                        name='currency'
                        label='Para Birimi'
                        wrapperClassName='col-md-3'
                        options={currencyOptions}
                      />
                      <SelectInput
                        name='balanceVisibleBranch'
                        label='Bakiye Görebilir Şube'
                        wrapperClassName='col-md-6'
                        options={branchOptions}
                      />
                      <SelectInput
                        name='customerClass'
                        label='Müşteri Sınıfı'
                        wrapperClassName='col-md-3'
                        options={CUSTOMER_CLASS}
                      />
                      <SelectInput
                        name='customerType'
                        label='Müşteri Türü'
                        wrapperClassName='col-md-3'
                        options={CUSTOMER_TYPES}
                      />
                      <SelectInput
                        name='customerRepresentative'
                        label='Müşteri Temsilcisi'
                        wrapperClassName='col-md-6'
                        options={personelOptions}
                      />
                      <SelectInput
                        name='hgsResponseType'
                        label='HGS Yansıtma Tipi'
                        wrapperClassName='col-md-6'
                        options={HGS_TYPES}
                      />
                       <AsyncSearchInput<AsyncReservationSourceModel>
                          name='reservationSource'
                          label='Rezervasyon Kaynağı'
                          placeholder='Rezervasyon kaynağı adı girin...'
                          fetchHandler={fetchAsyncReservationSourceData}
                          displayField={(item) => `${item.reservationSourceName}`}
                          onSelect={(item) => formik.setFieldValue('reservationSource', item.id)}
                          onClear={() => formik.setFieldValue('reservationSource', '')}
                          wrapperClassName='col-md-6'
                        />
                      <SelectInput
                        name='stoppageType'
                        label='Tevkifat Fatura Durumu'
                        wrapperClassName='col-md-6'
                        options={STOPPAGE_TYPES}
                      />
                      <SelectInput
                        name='stoppageCode'
                        label='Tevkifat Kodu'
                        wrapperClassName='col-md-6'
                        options={STOPPAGE_CODES}
                      />
                    </div>
                  )}
                  {tab === 'permission' && (
                    <div className='row g-5 align-items-center mb-2'>
                      <CheckboxInput name='passive' label='Pasif Et' wrapperClassName='col-md-3' />
                      <CheckboxInput
                        name='smsPermission'
                        label='SMS İzin'
                        wrapperClassName='col-md-3'
                      />
                      <CheckboxInput
                        name='mailPermission'
                        label='Mail İzin'
                        wrapperClassName='col-md-3'
                      />
                      <CheckboxInput
                        name='phonePermission'
                        label='Telefon İzin'
                        wrapperClassName='col-md-3'
                      />
                      <CheckboxInput
                        name='hideInvoiceDetail'
                        label='Faturada Detay Belirtme'
                        wrapperClassName='col-md-6'
                      />
                      <CheckboxInput
                        name='showRenterOnInvoice'
                        label='Faturaya Kiralayan Yaz'
                        wrapperClassName='col-md-6'
                      />
                      <CheckboxInput
                        name='customerCardAnonymized'
                        label='Müşteri Kartı Anonimleştir'
                        wrapperClassName='col-md-6'
                      />
                      <CheckboxInput
                        name='carNotAllowed'
                        label='Araç Verilemez'
                        wrapperClassName='col-md-3'
                      />
                      <CheckboxInput
                        name='findexRequired'
                        label='Findeks Gerekli'
                        wrapperClassName='col-md-3'
                      />
                      <CheckboxInput
                        name='reservationCardAnonymized'
                        label='Rezervasyon Kartı Anonimleştir'
                        wrapperClassName='col-md-6'
                      />
                      <CheckboxInput
                        name='ageLicenseFree'
                        label='Yaş-Ehliyet Serbest'
                        wrapperClassName='col-md-3'
                      />
                      <CheckboxInput
                        name='birthdayTracking'
                        label='Doğum Günü Takip'
                        wrapperClassName='col-md-3'
                      />
                      <CheckboxInput
                        name='rentalCardAnonymized'
                        label='Kira Kartı Anonimleştir'
                        wrapperClassName='col-md-6'
                      />
                      <CheckboxInput
                        name='hqCorporate'
                        label='Merkez Kurumsal'
                        wrapperClassName='col-md-3'
                      />
                      <CheckboxInput
                        name='brokerAgency'
                        label='Broker/Acente'
                        wrapperClassName='col-md-3'
                      />
                      <CheckboxInput
                        name='invoiceCardAnonymized'
                        label='Fatura Kartı Anonimleştir'
                        wrapperClassName='col-md-6'
                      />
                      <CheckboxInput
                        name='branchSpecific'
                        label='Şubeye Özel'
                        wrapperClassName='col-md-6'
                      />
                      <CheckboxInput
                        name='cashboxCardAnonymized'
                        label='Banka-Kasa Kartı Anonimleştir'
                        wrapperClassName='col-md-6'
                      />
                      <CheckboxInput
                        name='trafficHgsCardAnonymized'
                        label='Trafik ve HGS Ceza Kartı Anonimleştir'
                        wrapperClassName='col-md-6'
                      />
                    </div>
                  )}
                  {tab === 'other' && (
                    <>
                      <SubTabHeader tab={tabSub} setTab={setTabSub} tabs={customerSubTabs} />
                      {tabSub === 'address' && (
                        <div className='row g-5 align-items-center mb-2'>
                          {/* Adres ve İletişim Bilgileri */}
                          <TextAreaInput
                            name='businessAddress'
                            label='İş Adresi'
                            wrapperClassName='col-md-6'
                          />
                          <TextAreaInput
                            name='invoiceAddress'
                            label='Fatura Adresi'
                            wrapperClassName='col-md-6'
                          />
                          <PhoneInput
                            name='businessPhone'
                            label='İş Telefonu'
                            wrapperClassName='col-md-6'
                          />
                        </div>
                      )}
                      {tabSub === 'identity' && (
                        <div className='row g-5 align-items-center mb-2'>
                          {/* Kimlik Bilgileri */}

                          <TextInput
                            name='fatherName'
                            label='Baba Adı'
                            wrapperClassName='col-md-6'
                          />
                          <TextInput name='serialNo' label='Seri No' wrapperClassName='col-md-6' />
                          <TextInput
                            name='motherName'
                            label='Anne Adı'
                            wrapperClassName='col-md-6'
                          />
                          <TextInput name='volumeNo' label='Cilt No' wrapperClassName='col-md-6' />

                          <TextInput
                            name='registeredProvince'
                            label='Nüfus İli'
                            wrapperClassName='col-md-6'
                          />
                          <TextInput
                            name='familySequenceNo'
                            label='Aile Sıra No'
                            wrapperClassName='col-md-6'
                          />
                          <TextInput
                            name='registeredDistrict'
                            label='Nüfus İlçesi'
                            wrapperClassName='col-md-6'
                          />
                          <TextInput
                            name='sequenceNo'
                            label='Sıra No'
                            wrapperClassName='col-md-6'
                          />
                          <TextInput
                            name='registeredNeighborhood'
                            label='Nüfus Mahallesi'
                            wrapperClassName='col-md-6'
                          />
                        </div>
                      )}
                    </>
                  )}
                </Form>
              </div>
            </>
          )
        }}
      </Formik>
      <ToastContainer
        position='top-right'
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  )
}
